<template>
    <div class="dashboard" v-if="typeUser == 'admin'">
        <header
        class="page-header"
        style="display: flex; justify-content: space-between; align-items: center"
        >
            <div>
                <h2>Dashboard</h2>
            </div>
        </header>
        <div class="card mb-0">
            <CertificateDue
                :certificate_due="company.certificate_due"
            />

            <div class="row">

                <div class="col-12">
                    <div class="custom-collapse">
                        <div class="custom-collapse_header"
                            @click="changeShowStatistics"
                        >
                            <div>
                                {{ showStatistics ? 'Ocultar' : 'Mostrar' }} Estadísticas
                            </div>
                            <div>
                                <i class="fa"
                                    :class="showStatistics ? 'fa-chevron-up' : 'fa-chevron-down'"
                                ></i>
                            </div>
                        </div>
                        <div class="custom-collapse_content">
                            <KeepAlive>
                                <Totals
                                    v-if="showStatistics" key="statistics-panel"
                                    :utilities="utilities"
                                />
                            </KeepAlive>
                            <KeepAlive>
                                <Statistics
                                    v-if="showStatistics" key="statistics-panel"
                                    :soapCompany="soapCompany"
                                    :configuration="configuration"
                                    @changeUtilities="reloadDataUtilities" @utilitiesLoaded="setUtilities"
                                />
                            </KeepAlive>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="custom-collapse">
                        <div class="custom-collapse_header"
                            @click="changeShowReports"
                        >
                            <div>
                                {{ showReports ? 'Ocultar' : 'Mostrar' }} Reportes Estratégicos
                            </div>
                            <div>
                                <i class="fa"
                                    :class="showReports ? 'fa-chevron-up' : 'fa-chevron-down'"
                                ></i>
                            </div>
                        </div>
                        <div class="custom-collapse_content">
                            <KeepAlive>
                                <ReportsStrategics
                                    v-if="showReports" key="reports-panel"
                                    :configuration="configuration"
                                    :form="form"
                                />
                            </KeepAlive>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.widget-summary .summary {
  min-height: inherit;
}
.custom-badge {
  font-size: 15px;
  font-weight: bold;
}
.card.card-dashboard .table td,
.card.card-dashboard .table th {
    font-size: 0.9rem;
    font-weight: 500;
}
</style>
<script>
import {mapActions, mapState} from "vuex/dist/vuex.mjs";
import CertificateDue from "../components/CertificateDue.vue"
import Totals from "../components/Totals.vue"
import Statistics from "../components/Statistics.vue"
import ReportsStrategics from "../components/ReportsStrategics.vue"

export default {
  props: ["typeUser", "soapCompany",'configuration'],
  components: { /*DashboardStock, LoaderGraph, RowTop, DashboardInventory,*/
    CertificateDue,
    Totals,
    Statistics,
    ReportsStrategics
   },
  data() {
    return {
        resource: "dashboard",
        company: {},
        activePanel: null,
        form: {},
        utilities: {
            totals: {},
            graph: {},
        },
        showStatistics: false,
        showReports: false,
        establishments: [],
    };
  },
  async created() {
    this.loadConfiguration()
    this.$store.commit('setConfiguration', this.configuration)
    this.initForm(); // creo que se tendría que quitar
    this.loadCompany();
    await this.fetchFilters()
  },

  methods: {
    ...mapActions([
            'loadConfiguration',
        ]),
    initForm() {
      this.form = {
        item_id: null,
        establishment_id: null,
        enabled_expense: null,
        enabled_move_item: false,
        enabled_transaction_customer: false,
        period: "last_week",
        date_start: moment().subtract(7, 'days').format("YYYY-MM-DD"),
        date_end: moment().format("YYYY-MM-DD"),
        month_start: moment().format("YYYY-MM"),
        month_end: moment().format("YYYY-MM"),
        customer_id: null,
      };
    },
    
    loadCompany() {
      this.$http.get(`/companies/record`).then((response) => {
        this.company = response.data.data;
      });
    },
    
    onPanelChange(name) {
        if (name === 'statistics') {
            this.$nextTick(() => {
                // espera a que se muestre el DOM
                setTimeout(() => {
                    this.$eventHub.$emit('dashboard:resize-charts')
                }, 50)
            })
        }
    },

    changeShowStatistics() {
        this.showStatistics = !this.showStatistics
    },

    changeShowReports() {
        this.showReports = !this.showReports
    },

    setUtilities(utilities) {
        this.utilities = utilities
    },

    reloadDataUtilities(form) {
        this.form = { ...form }
    },

    async fetchFilters() {
        await this.$http.get(`/${this.resource}/filter`).then((response) => {
            this.establishments = response.data.establishments;
            this.form.establishment_id = this.establishments.length > 0 ?
                                            this.establishments[0].id : null;
            this.$eventHub.$emit("changeStock", this.form.establishment_id)
        })
    },
  },
};
</script>


<style>
    .custom-collapse {
        width: 100%;
    }

    .custom-collapse_header {
        padding: 8px;
        cursor: pointer;
        font-weight: 700;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        color: #60769a;
        border-radius: 8px;
    }

    html.dark .custom-collapse_header {
        background-color: #283046;
        color: #fff;
    }

    .custom-collapse_content {
        margin-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/index.vue